import React, { useEffect, useState } from 'react';
import Header from './Header';
import Navigation from './Navigation';
import './v1.css'; 
import './v1-mobile.css'; 

function App() {


  return (
    <main>
      {/* <Header /> */}
      <Navigation />
    </main>
  );
}

export default App;
